/*
 * Modo claro por defecto en las páginas de Rio (collection rio-1923, product rio-oliveira y product rio-reconquista).
 * Solo se carga en esas plantillas, desde snippets/rio-head.liquid.
 *
 * La preferencia de Rio se guarda aparte (localStorage.rio_theme: 0 claro, 1 oscuro) y nunca toca la del
 * resto de la web (localStorage.eurus_theme), así que al salir de Rio cada página vuelve a aplicar la suya.
 */
(function () {
  var RIO_KEY = 'rio_theme';

  function rioDark() {
    try {
      return localStorage.getItem(RIO_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function guardar(dark) {
    try {
      localStorage.setItem(RIO_KEY, dark ? '1' : '0');
    } catch (e) {}
  }

  function pintar(dark) {
    document.documentElement.classList.toggle('dark', dark);
  }

  pintar(rioDark());
  // theme-mode-control.liquid aplica el modo global en un requestAnimationFrame; este se encola detrás
  // y se ejecuta después, antes del primer pintado.
  requestAnimationFrame(function () {
    pintar(rioDark());
  });

  // Los botones de modo (header y menú móvil) llaman a $store.xDarkMode, definido en theme.js, que guarda
  // en eurus_theme. En Rio se sustituyen sus métodos para que guarden en rio_theme.
  document.addEventListener('alpine:initialized', function () {
    var store = Alpine.store('xDarkMode');
    if (!store) return;

    function cambiar(dark) {
      Alpine.store('xDOM').rePainting = store.alias;
      setTimeout(function () {
        guardar(dark);
        pintar(dark);
        Alpine.store('xHeaderMenu').setTopStickyHeader();
        Alpine.store('pseudoIconTheme').updatePseudoIconInputTheme();

        Alpine.store('xDOM').rePainting = null;
      }, 200); // INP, igual que theme.js
    }

    store.toggleThemeMode = function () {
      cambiar(!document.documentElement.classList.contains('dark'));
    };
    store.toggleLightMode = function () {
      cambiar(false);
    };
    store.toggleDarkMode = function () {
      cambiar(true);
    };

    // El original lee eurus_theme; en Rio tiene que seguir el modo de Rio.
    var pseudo = Alpine.store('pseudoIconTheme');
    if (pseudo) {
      pseudo.updatePseudoIconInputTheme = function () {
        var dark = rioDark();
        document.querySelectorAll('input[type="date"], input[type="time"]').forEach(function (input) {
          if (dark) {
            input.style.colorScheme = 'dark';
          } else {
            input.removeAttribute('style');
          }
        });
      };
      pseudo.updatePseudoIconInputTheme();
    }
  });
})();
